import { useTranslation } from 'react-i18next';

import useCurrency from 'hooks/useCurreny';
import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

const SynthesisTableColumns = ({
  pdfColumnWidth,
  isPDF,
}: {
  pdfColumnWidth: { [key: string]: string };
  isPDF?: boolean;
}) => {
  const { t } = useTranslation();
  const { currencyGreen } = useCurrency();
  const { onlyAc, onlyMt } = useCroptimizer();

  return (
    <div className="flex p-4 border-b pb-4 divide-x">
      <div className={`w-[350px]  ${isPDF ? pdfColumnWidth['2'] : ''} px-2 pl-3`}>
        <div className="font-bold text-sm flex justify-center">
          {t('productName')}
        </div>
      </div>

      <div
        className={`flex justify-center text-center font-bold text-sm px-2 w-[185px] ${
          isPDF ? pdfColumnWidth['2'] : ''
        }`}
      >
        {t('area')} ({onlyAc})
      </div>

      <div className={`w-[185px]  ${isPDF ? pdfColumnWidth['2'] : ''} px-2`}>
        <div className="font-bold text-sm mb-4 flex justify-center">
          {t('total')} ({onlyMt})
        </div>
      </div>

      <div className={`w-[185px]  ${isPDF ? pdfColumnWidth['2'] : ''} px-2`}>
        <div className="font-bold text-sm mb-4 flex justify-center">
          {t('price')} ({currencyGreen}/{onlyMt})
        </div>
      </div>

      <div className={`w-[185px]  ${isPDF ? pdfColumnWidth['2'] : ''} px-2`}>
        <div className="font-bold text-sm mb-4 flex justify-center">
          {t('cost')} ({currencyGreen})
        </div>
      </div>
    </div>
  );
};

export default SynthesisTableColumns;
